import { Button } from "@mui/material";
import React, { useState } from "react";
import { useLanguage } from "../../Language";

export interface CancelHoldButtonProps {
  disabled?: boolean;
  onClick: () => void | Promise<void>;
}

export const CancelHoldButton: React.FC<CancelHoldButtonProps> = ({
  disabled,
  onClick,
}) => {
  const { translate } = useLanguage();
  const [loading, setLoading] = useState<boolean>(false);

  const handleCancelHold = async (): Promise<void> => {
    setLoading(true);
    await onClick();
    setLoading(false);
    return;
  };

  return (
    <Button disabled={disabled} loading={loading} onClick={handleCancelHold}>
      {translate("cancelHold")}
    </Button>
  );
};
